import { useEffect } from 'react';
import { Stepper, Step, StepLabel, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'src/redux-app-hooks';
import { NotificationSeverity, showSnackbar } from '../notifications/notifications.slice';
import { STEPS } from './steps';
import { hydrateFromQueryParams } from './offer-evaluation.slice';
import { useOfferEvaluationStepFromUrl, useTenderIdFromUrl } from './hooks';

export default function OfferEvaluationPage() {
    const { errorMessage } = useAppSelector((state) => state.offerEvaluation);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const [tenderId] = useTenderIdFromUrl();
    useEffect(() => {
        if (!tenderId) {
            return;
        }
        dispatch(hydrateFromQueryParams(tenderId));
    }, [tenderId, dispatch]);

    const [activeStep] = useOfferEvaluationStepFromUrl();

    useEffect(() => {
        if (errorMessage) {
            dispatch(showSnackbar({ message: errorMessage, severity: NotificationSeverity.Error }));
        }
    }, [errorMessage, dispatch]);

    return (
        <div>
            <Stepper activeStep={activeStep}>
                {STEPS.map(([label], index) => (
                    <Step key={index}>
                        <StepLabel>{t(label)}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box sx={{ mt: 2 }}>{STEPS[activeStep] && STEPS[activeStep][1]}</Box>
        </div>
    );
}
